namespace Solovis.UI {

    /**
     * Toolbar will be used to build up and maintain a list of interactive/clickable elements.
     * 
     * constructor options:
     *      width: width of the toolbar
     *      container: element within which to add the toolbar items.
     */
    export class Toolbar {

        public _options;
        public _container;
        public _itemNameToItemMap;
        public _width;
        public _useTransparentBackground;


        constructor(options) {
            this._options = options;

            this._container = options.container;

            this._itemNameToItemMap = {};

            this._width = options.width ? options.width : null;

            this._useTransparentBackground = options.useTransparentBackground ? true : false;

            this._setupContainer();
        }

        public _setupContainer() {
            var self = this;

            this._container.addClass("solovis-toolbar no-print");

            if (this._useTransparentBackground) {
                this._container
                    .css("background-color", "transparent");
            }

            if (Solovis.isNotNull(this._width)) {
                this.width(this._width);
            }
        }

        public width(newWidth) {
            if (arguments.length) {
                this._width = newWidth;

                if ($.isNumeric(this._width)) {
                    this._container.width(this._width);
                }
                else if (this._width.indexOf("%") !== -1 ||
                    this._width.indexOf("px") !== -1 ||
                    this._width.indexOf("em") !== -1) {
                    this._container.css("width", this._width);
                }
            }
            else {
                return this._width;
            }
        }


        /**
         * Retrieve ToolbarItem instance by name. Throws exception if item for name is not found. Does not throw exception if item for name is not found.
         */
        public tryGetItemByName(name) {      
            var item = this._itemNameToItemMap[name];
            if (item) {
                return item;
            }
            else {
                return null;
            }
        }

        /**
         * Retrieve ToolbarItem instance by name. Throws exception if item for name is not found.
         */
        public getItemByName(name) {          
            var item = this.tryGetItemByName(name);
            if (item) {
                return item;
            }
            else {
                throw "Solovis.UI.Toolbar: No toolbar item found for name: " + name;
            }
        }

        /**
         * Remove Toolbar item by name. Does not throw exception if item for name is not found.
         */
        public removeItemByName(name) {            
            var item = this.tryGetItemByName(name);
            if (item) {
                var elementToRemove = item.getElement();
                if (elementToRemove) {
                    elementToRemove.remove();
                    this._itemNameToItemMap[name] = null;
                }
            }
        }

        public length() {
            return this._itemNameToItemMap.length;
        }

        public elementAt(index) {
            if (Solovis.isNotNull(index)) {
                return this._container.eq(index);
            }
            console.log("Solovis.UI.Toolbar.Toolbar: invalid index.");
            return null;
        }

        public itemAt(index) {
            if (Solovis.isNotNull(index)) {
                return this._itemNameToItemMap[index];
            }
            console.log("Solovis.UI.Toolbar.Toolbar: invalid index.");
            return null;
        }

        public addItem(itemOptions, alignment?, index?) {
            var self = this;

            // Create the ToolbarItem and add it to our collections.
            var toolbarItem = new (Solovis as any).UI.Toolbar.ToolbarItem({
                toolbar: this,
                itemOptions: itemOptions
            });

            this._itemNameToItemMap[toolbarItem.name] = toolbarItem;

            var elementToAppend = toolbarItem.getElement();

            if (itemOptions.alignment && itemOptions.alignment === "right") {
                elementToAppend.css("float", "right");
            }

            if (Solovis.isNotNull(itemOptions.displayInline) && itemOptions.displayInline === false) {
                elementToAppend.css("display", "block");
            }
            else {
                elementToAppend.css("display", "inline-block");
            }

            if (Solovis.isNotNull(index)) {
                this._container.eq(index).after(elementToAppend);
            }
            else {
                this._container.append(elementToAppend);
            }

            return toolbarItem;
        }

        public getContainer() {
            return this._container;
        }
    }

}

namespace Solovis.UI.Toolbar {

    /**
     * ToolbarItem represents one element within a Toolbar.
     * 
     * itemOptions:
     *  name: name is a unique identifier
     *  createItem: function() that returns toolbarItem
     *  getElement: function(createdToolbarItem) that returns a reference to the jquery element hosted by the ToolbarItem
     *  postSetup: function(toolbarItem) method called by ToolbarItem after all items are added (this is actually handled by ToolbarBuilder)
     *            
     */
    export class ToolbarItem {

        public _toolbar;
        public name;
        public _toolbarItem;

        constructor(options) {
            var self = this;
            var toolbar = options.toolbar;
            var itemOptions = options.itemOptions;

            var name = itemOptions.name;

            var createToolbarItem = itemOptions.createToolbarItem;
            var toolbarItem = createToolbarItem();

            this._toolbar = toolbar;
            this.name = name;
            this._toolbarItem = toolbarItem;

            if (!this._toolbarItem.getElement) {
                if (!itemOptions.getCreatedElement) {
                    throw "Solovis.UI.Toolbar.ToolbarItem: getCreatedElement is not defined for ToolbarItem " + itemOptions.name;
                }
                this._toolbarItem.getElement = itemOptions.getCreatedElement;
            }            
        }

        public getElement() {
            var element = this._toolbarItem.getElement();
            return element;
        }


        public getHostedItem() {
            return this._toolbarItem;
        }

        public remove() {
            this._toolbar.removeItemByName(this.name);
        }

        public isVisible() {
            var itemElement = this.getElement();
            return itemElement.is(":visible");
        }

        public showItem(visible) {
            var itemElement = this.getElement();

            itemElement.toggle(visible);
        }
    }

}
